import React from 'react';
import { portfolioSlots } from '../data/portfolio';

/**
 * Each frame is a browser-window mockup wrapping a real client screenshot.
 * Screenshot URLs and labels live in data/portfolio.ts — add a new entry there
 * to add another site to this strip.
 */
export function Portfolio() {
  return <section className="bg-brand-black text-brand-white" aria-labelledby="portfolio-heading" data-id="element-80" data-mp="2kb9rhb1sr589">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20 lg:py-24" data-id="element-81" data-mp="3hz0d4drkzcng">
        <div className="max-w-3xl" data-id="element-82" data-mp="3czfde14l709o">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-brand-red sm:text-xs" data-id="element-83" data-mp="3d0gq0a193uti">
            Proof, not promises
          </p>
          <h2 id="portfolio-heading" className="mt-4 font-display text-3xl font-extrabold leading-[1.1] tracking-tight sm:text-4xl lg:text-[2.75rem]" data-id="element-84" data-mp="386mcjoc8oc2v">
            Real Businesses, Real Sites, Built Fast.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-brand-light" data-id="element-85" data-mp="3vx8hh6qy5g8n">
            Every one of these started as a 72-hour shell, then kept evolving through Slack.
          </p>
        </div>

        <ul className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-7" data-id="element-86" data-mp="mo5mw16y39yp">
          {portfolioSlots.map(slot => <li key={slot.id} className="flex flex-col" data-id="element-87" data-mp="8w8xw60kpg6j">
              <figure className="flex flex-1 flex-col" data-id="element-88" data-mp="dushw0vlwhw9">
                <div className="overflow-hidden rounded-lg border border-brand-white/15 bg-brand-white shadow-[0_18px_40px_-18px_rgba(0,0,0,0.9)]" data-id="element-89" data-mp="dt936eplmewl">
                  <div className="flex items-center gap-1.5 border-b border-brand-light bg-brand-light px-3 py-2" data-id="element-90" data-mp="3yh230wt59x2">
                    <span className="h-2.5 w-2.5 rounded-full bg-brand-red" aria-hidden="true" data-id="element-91" data-mp="3m4lo36qh12n4" />
                    <span className="h-2.5 w-2.5 rounded-full bg-brand-gray" aria-hidden="true" data-id="element-92" data-mp="3r2njmr532ufh" />
                    <span className="h-2.5 w-2.5 rounded-full bg-brand-black/30" aria-hidden="true" data-id="element-93" data-mp="1kcz2xlt9g1yk" />
                  </div>
                  <img src={slot.image} alt={`${slot.name} website homepage`} loading="lazy" decoding="async" className="aspect-[4/3] w-full bg-brand-white object-cover object-top" data-id="element-94" data-mp="1mx5cc90n8kmi" />
                </div>
                <figcaption className="mt-3" data-id="element-95" data-mp="18y5lqvtklvnp">
                  <span className="block text-xs font-bold uppercase tracking-[0.14em] text-brand-red" data-id="element-96" data-mp="26kl2fve6apa7">
                    {slot.category}
                  </span>
                  <span className="mt-1 block text-sm font-semibold text-brand-light" data-id="element-97" data-mp="21n30wq2hjcc8">
                    {slot.name}
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}